module.exports = __webpack_public_path__ + "static/ebook-783652f20c52fc84685ee20edce94e70.jpg";